import { FC } from 'react';
import { DSORootStyle } from 'styles/GlobalStyles';
import { LayoutProps } from '../../Layout';
import { I18nProvider } from 'contexts/i18n';
import { DSOHeader } from '../Header';
import { DSOFooter } from '../Footer';
import { S } from './';
import { useDsoFetchPermissions } from 'reactQuery/queries/dso/useDsoFetchPermissions';
import DSOStoreDisabledMessage from '../DSOStoreDisabledMessage/DSOStoreDisabledMessage';
import { LoadingBar } from 'components/core';

const DSOLayout: FC<LayoutProps> = ({ children }) => {
  const { data: dsoPermissions, isLoading, isError } = useDsoFetchPermissions();
  const hasRequiredPermission =
    dsoPermissions?.permissions?.some(permission =>
      ['all', 'userAdmin', 'webstoreFullAccess', 'webstoreReadOnly'].includes(
        permission
      )
    ) ?? false;

  return (
    <I18nProvider locale={'en-US'}>
      <DSORootStyle />
      <S.LayoutContainer>
        <DSOHeader />
        <S.ContentArea>
          {isLoading ? (
            <LoadingBar />
          ) : isError ? (
            <DSOStoreDisabledMessage isError />
          ) : hasRequiredPermission ? (
            children
          ) : (
            <DSOStoreDisabledMessage />
          )}
          <DSOFooter />
        </S.ContentArea>
      </S.LayoutContainer>
    </I18nProvider>
  );
};
export default DSOLayout;
